// initial state
// shape: [{ id, quantity }]
const state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getTekeCustomerTable ({commit, state}, params) {
    let promised = request.alert('getTekeCustomerTable', params)
    return promised
  },
  setPlatformFee ({commit, state}, params) {
    let promised = request.alert('setPlatformFee', params)
    return promised
  },
  deleteTekeCustomer ({commit, state}, id) {
    let promised = request.alert('deleteTekeCustomer', id)
    return promised
  },
  getTekeMemberTable ({commit, state}, params) {
    let promised = request.alert('getTekeMemberTable', params)
    return promised
  },
  createCustomer ({commit, state}, id) {
    let promised = request.alert('createCustomer', id)
    return promised
  },
  editTekeCustomer ({commit, state}, id) {
    let promised = request.alert('editTekeCustomer', id)
    return promised
  },
  getTekeCustomer ({commit, state}, id) {
    let promised = request.alert('getTekeCustomer', id)
    return promised
  },
  batchEditPlatformFee ({commit, state}, params) {
    let promised = request.alert('batchEditPlatformFee', params)
    return promised
  },
  createCustomerMember ({commit, state}, params) {
    let promised = request.alert('createCustomerMember', params)
    return promised
  },
  editCustomerMember ({commit, state}, params) {
    let promised = request.alert('editCustomerMember', params)
    return promised
  },
  getTekeCustomerDetail ({commit, state}, id) {
    let promised = request.alert('getTekeCustomerDetail', id)
    return promised
  },
  getTekeCustomerBalance ({commit, state}, id) {
    let promised = request.alert('getTekeCustomerBalance', id)
    return promised
  },
  getTekeCustomerRechargeTable ({commit, state}, id) {
    let promised = request.alert('getTekeCustomerRechargeTable', id)
    return promised
  },
  createCustomeRecharge ({commit, state}, id) {
    let promised = request.alert('createCustomeRecharge', id)
    return promised
  },
  getTekeCustomerBalanceTable ({commit, state}, params) {
    let promised = request.alert('getTekeCustomerBalanceTable', params)
    return promised
  },
  UploadTekeFile ({commit, state}, params) {
    let promised = request.alert('UploadTekeFile', params)
    return promised
  },
  getTekeCustomerMember ({commit, state}, id) {
    let promised = request.alert('getTekeCustomerMember', id)
    return promised
  },
}

// mutations
const mutations = {}

export const tekeCustomer = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/teke-customer/tekeCustomer.store.js